import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["limit"];
import { generateActivityFiltersV3 } from '../utils';
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */
var generateV3ActivityFilters = function generateV3ActivityFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = filters.limit,
    restFilters = _objectWithoutProperties(filters, _excluded);
  return generateActivityFiltersV3(restFilters);
};
export default generateV3ActivityFilters;